import { getParameterByName, neverThrow } from "./util"

/**
 * If this is marketplace auth, save a flag in local storage so that we don't lose
 * that info even if the browser url changes.
 */
export const setMarketplaceAuthFlag = () => {
  const isMarketplaceAuth = getParameterByName("marketplaceLogin")

  if (isMarketplaceAuth) {
    localStorage.setItem("marketplaceLogin", "true")
  }
}

/**
 * If the marketplace flag is set, and there's a parent window, we don't want to
 * redirect this window away from the marketplace
 */
export const shouldOpenNewWindowFromMarketplace = () => {
  return window.top !== window.self && localStorage.getItem("marketplaceLogin") === "true"
}

export const marketplaceIsParent = () =>
  neverThrow(() => window.top !== window.self && localStorage.getItem("marketplaceLogin") === "true") ?? false
